import React, { useEffect, useState } from "react";
import { useField, useFormikContext } from "formik";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import { Select2 } from "select2-react-component";

const getFieldCSSClasses = (touched, errors) => {
  // const classes = ["form-control", "form-control-solid"];
  const classes = [];
  if (touched && errors) {
    classes.push("is-invalid-select");
  }

  if (touched && !errors) {
    classes.push("is-valid-select");
  }

  return classes.join(" ");
};

export function CustomeSelect({
  label,

  withFeedbackLabel = true,
  type = "text",
  customFeedbackLabel,
  children,
  ...props
}) {
  const [field, meta] = useField(props);
  const { setFieldValue, } = useFormikContext();
  const [options, setOptions] = useState([]);
  const [count, setCount] = useState(0);
  const { touched, error } = meta;
  const constUpdateValue = (val) => {
    setFieldValue(field.name, val);
  }
  const clearValue = () => {
    setFieldValue(field.name, undefined);
    setCount(count + 1);
    if (document.getElementById(field.name).getElementsByClassName('select2-selection__rendered')) {
      document.getElementById(field.name).getElementsByClassName('select2-selection__rendered')[0].innerHTML = `<span class="select2-selection__placeholder">Audit Reason</span>`;
      var p = document.getElementById(field.name).getElementsByClassName('select2-results__option--highlighted')[0];
      if (p) {
        if (p.classList) {
          p.classList = 'select2-results__option';
        }
        for (let i in p.attributes) {
          if (p.attributes[i].name === 'aria-selected') {
            p.attributes[i].value = "false";
          }
        };
      }
    }
    if (props.onClear) {
      props.onClear();
    }
  }
  const LoadSelect = () => {
    return (
      <>
        <Select2
          className={getFieldCSSClasses(touched, error)}
          {...props}
          {...field}
          update={value => constUpdateValue(value)}
          data={options}
        >
          {children}
        </Select2>
        {props.clearValue && (
          <div className="c-pointer clear-select2 flaticon2-cross" onClick={() => clearValue()}></div>
        )}
        {
          withFeedbackLabel && (
            <FieldFeedbackLabel
              erros={error}
              touched={touched}
              label={label}
              customFeedbackLabel={customFeedbackLabel}
            />
          )
        }
      </>
    )
  }
  useEffect(() => {
    let data = props.data
    if (props.valueKey && props.labelKey && props.data) {
      data = props.data.map((item) => { return { value: item[props.valueKey], label: item[props.labelKey] } })
    }
    setOptions(data);
  }, [props.data, props.labelKey, props.valueKey]);
  return (
    <>
      <div id={field.name} className={'position-relative'}>
        {label && <label className={props.isRequired ? 'required' : ''}>Select {label}</label>}
        <LoadSelect />
      </div>
    </>
  );
}
